/*
 * File: DialogHeaderSkeleton.tsx
 * Author: Austin Robinson
 * Date Created: 12/07/2025
 * Copyright (c) DrivingDoc 2025
 */
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Skeleton from '@mui/material/Skeleton';

interface DialogHeaderSkeletonProps {
  onClose: () => void;
}

/**
 * Skeleton loader for DialogHeader component
 * Mirrors the structure and spacing of the actual DialogHeader
 */
export default function DialogHeaderSkeleton({ onClose }: DialogHeaderSkeletonProps) {
  return (
    <DialogTitle sx={{ bgcolor: 'primary.lighter', py: 1.5 }}>
      {/* First Line: Course Title and Close Button */}
      <Box display="flex" alignItems="center" justifyContent="space-between" gap={2} mb={0.5}>
        <Skeleton width="60%" height={36} />
        <IconButton aria-label="close" onClick={onClose} size="small" sx={{ color: 'text.secondary' }}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Second Line: Section, Date/Time, and Status */}
      <Box display="flex" alignItems="center" flexWrap="wrap" gap={2}>
        <Skeleton width={200} height={20} />
        <Skeleton width={150} height={20} />
      </Box>
    </DialogTitle>
  );
}
